<script>
import headerGas from "@/assets/gas_header.jpg";
import RightColumnGroup from "@/components/layout/RightColumnGroup.vue";
import {mapGetters} from "vuex";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";

export default {
  name: "GasView",
  components: {Breadcrumbs, RightColumnGroup},
  data: () => ({
    header: headerGas,
  }),
  computed: {
    ...mapGetters('user', ['userCommunePartner', 'userCommuneRegionalLeader', "userCommuneName", "getDashboardCommunePartners"]),
    hideServices() {
const communesToHide = ["Selfkant", "Übach-Palenberg", "Waldfeucht", "Wassenberg"];

      return communesToHide.includes(this.userCommuneName);
    },
    sidebarConfig() {
      return {
        showRegionalLeiter: false,
        personsInCharge: this.getDashboardCommunePartners,
        interestingLinks: [
          { id: 0, title: "Günstiger Energieversorger für Strom & Gas | NEW Energie ", link: "https://www.new-energie.de/" },
          !this.hideServices ? { id: 1, title: "NEW Netz - Ihr Parner für sichere Energieversorgung", link: "https://www.new-netz.de/" } : null
        ].filter(link => link !== null)
      }
    },
    text() {
      if(this.hideServices) {
        return `
        <p class="font-weight-bold">NEW Energie: Erdgaslieferung zuverlässig und partnerschaftlich</p>
        <p>
        Zuverlässigkeit, Effizienz, Klimaschutz, Digitalisierung und Innovationen im Energiesektor - unter diesen Prämissen liefert die NEW Niederrhein Energie und Wasser GmbH servicestark Erdgas für die Kommunen. Außerdem erbringt sie ergänzend viele weitere energienahe Dienstleistungen. <br><br>
        Als regionaler Strom- und Erdgaslieferant ist die NEW Niederrhein Energie und Wasser GmbH prämiert: zum einen als “Top-Lokalversorger 2021”, zum anderen für ihren exzellenten Kundenservice mit dem Zertifikat Service Excellence des TÜV SÜD. <br><br>
        Kund:innen können aus verschiedenen Tarifen wählen. Sie unterscheiden sich zum Beispiel in ihrer Ökobilanz, ihrer Laufzeit und dem Umfang des Kundenservice. Kommunen bietet die NEW Niederrhein Energie und Wasser GmbH maßgeschneiderte Energielieferungen an oder nimmt an deren Ausschreibungen teil. <br><br>
        Die Bandbreite der Dienstleistungen reicht vom Energieaudit bis hin zu ganzheitlichen Wärmekonzepten und -angeboten jeglicher Größenordnung. <br><br>
        An sechs persönlichen Beratungsstellen, telefonisch über die Hotline und digital rund um die Uhr ist die NEW Niederrhein Energie und Wasser GmbH für ihre Kund:innen erreichbar - ein ausgezeichneter partnerschaftlicher Service! <br><br>
        </p>`
      }

      return `
        <p class="font-weight-bold">Erdgasversorgung und Erdgasnetz </p>
        <p>
        Eine sichere, wirtschaftliche und zukunftsorientierte Erdgasversorgung ist ein wichtiger Bestandteil der kommunalen Infrastruktur. Gemeinsam gewährleisten die NEW Niederrhein Energie und Wasser GmbH als Energielieferant und die NEW Netz GmbH als Verteilnetzbetreiber eine zuverlässige Versorgung von Privathaushalten, Unternehmen und kommunalen Einrichtungen in der Region. <br><br>
        Die NEW Niederrhein Energie und Wasser GmbH steht für Versorgungssicherheit, Effizienz, Klimaschutz, Digitalisierung und innovative Energielösungen. Kundinnen und Kunden können aus verschiedenen Erdgastarifen wählen, die sich beispielsweise hinsichtlich Laufzeit, Serviceumfang und Nachhaltigkeitsaspekten unterscheiden. Kommunen profitieren von individuell zugeschnittenen Energielieferungen und einer partnerschaftlichen Begleitung bei Ausschreibungen und Beschaffungsprozessen. <br><br>
        Über die reine Energielieferung hinaus bietet die NEW vielfältige energienahe Dienstleistungen an. Das Leistungsspektrum reicht von Energieaudits über Beratungsleistungen bis hin zu ganzheitlichen Wärme- und Versorgungskonzepten unterschiedlicher Größenordnungen.  <br><br>
        Die technische Grundlage für eine sichere Versorgung schafft die NEW Netz GmbH. Als Verteilnetzbetreiber plant, baut und betreibt sie das Erdgasnetz. Durch kontinuierliche Investitionen in die Infrastruktur sowie die Berücksichtigung neuer technischer und regulatorischer Anforderungen stellt die NEW Netz die Versorgungssicherheit auch langfristig sicher. Dazu gehören beispielsweise die Integration neuer Technologien sowie die fortlaufende Modernisierung der Netzinfrastruktur. <br><br>
        Zu den Aufgaben der NEW Netz zählen neben dem Netzbetrieb auch der Messstellenbetrieb und das Messwesen. Sie installiert und betreibt die erforderlichen Messeinrichtungen, erfasst Verbrauchsdaten und sorgt für die sichere Übermittlung der Ablesewerte. Darüber hinaus realisiert sie Netzanschlüsse für Privatkunden, Unternehmen und kommunale Einrichtungen. <br><br>
        Als Betreiber kritischer Infrastruktur erfüllt die NEW Netz die besonderen gesetzlichen Anforderungen an Sicherheit und Zuverlässigkeit. Ergänzend lässt sie ihre Prozesse regelmäßig im Rahmen des Technischen Sicherheitsmanagements prüfen und zertifizieren. Damit trägt sie wesentlich zu einem sicheren und stabilen Netzbetrieb in der Region bei. <br><br>
        Kundennähe und Service haben bei der NEW einen hohen Stellenwert. An mehreren persönlichen Beratungsstandorten, über telefonische Hotlines sowie über digitale Serviceangebote stehen kompetente Ansprechpartnerinnen und Ansprechpartner zur Verfügung. Die Mitarbeitenden aus Planung, Bau und Betrieb sind regional verankert und sorgen für kurze Wege sowie eine schnelle Unterstützung vor Ort. <br><br>
        Über das <a href="https://gis.geo.new.de" target="_blank">View-Portal</a> können Ver- und Entsorgungsleitungen innerhalb des Konzessionsgebiets komfortabel eingesehen werden. Zusätzlich steht ein WMS-Dienst zur Verfügung, der die Integration der bereitgestellten Karten in eigene GIS-Systeme ermöglicht. Dadurch können kommunale Planungen und Projekte effizient mit den vorhandenen Leitungsinformationen verknüpft werden.
</p>

      `
    }
  }
}
</script>

<template>
  <div class="strom-view min-height-100">
    <v-img
        :src="header"
        aspect-ratio="2.1333"
        max-height="450px"
        class="gas-header"
    >
      <span
          class="custom-header-text new-font-bold white--text"
          style="position: absolute; bottom: 20px; left: 35px;"
      >
        Gas
      </span>
    </v-img>
    <v-row no-gutters class="gas-content">
      <v-col cols="12" sm="8" class="new-wrapper px-10 py-4">
        <breadcrumbs />
        <div v-html="text"></div>
      </v-col>
      <v-col
          cols="12"
          sm="4"
          class="contact_container pl-4"
      >
        <RightColumnGroup
            :communePartner="userCommunePartner"
            :communeRegionalLeader="userCommuneRegionalLeader"
            :contentObject="sidebarConfig"
        />
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.gas-view {
  display: flex;
  flex-direction: column;
}

.gas-header {
  flex-shrink: 0;
}

.gas-content {
  flex: 1;
}
</style>
